<template>

    <v-card class="section-card px-5 py-5" outlined>
      <v-container v-if="this.externalUser" class="fixed-component mt-n3 pa-1" fluid>
            <v-row align="center" justify="center">
                <v-col cols="1">
                    <v-btn class="mt-n7" @click="backToTrades">« {{ $t('btnBack') }}</v-btn>
                </v-col>
                <v-col class="ml-n3" cols="11">
                    <OverallFilters :external-user="externalUser" :external-user-id="externalUserId"/>
                </v-col>
            </v-row>
            <v-divider class="mb-5 mt-n5"/>
        </v-container>
        <div class="desktop">
        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.portfolio') }}</h2>
          <v-chip v-if="!isEmbedded" small class="ml-3" @click="educationalVideo('Portfolio')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <PortfolioStats/>


      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.asset') }}</h2>
          <v-chip v-if="!isEmbedded" small class="ml-3" @click="educationalVideo('Asset')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <AssetStats/>

      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.side') }}</h2>
          <v-chip v-if="!isEmbedded" small class="ml-3" @click="educationalVideo('Side')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <SideStats/>
      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.time') }}</h2>
          <v-chip v-if="!isEmbedded"  small class="ml-3" @click="educationalVideo('Time')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <TimeStats/>

      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.mood') }}</h2>
          <v-chip v-if="!isEmbedded"  small class="ml-3" @click="educationalVideo('Mood')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <MoodStats/>

      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.strategy') }}</h2>
          <v-chip v-if="!isEmbedded" small class="ml-3" @click="educationalVideo('Strategy')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <StrategyStats/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.swisetRatio') }}</h2>
          <v-chip v-if="!isEmbedded"  small class="ml-3" @click="educationalVideo('SwisetRatio')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
          <v-chip class="ml-2" small><p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p></v-chip>
        </div>
        <SwisetRatioStats @goToPro="seeProAdvantages = true"/>

      <div class="d-flex align-center">
        <h2>{{ $t('titles_JournalStats.riskAndReturn') }}</h2>
        <v-chip class="ml-2" small>
          <p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p>
        </v-chip>
      </div>
      <RiskReturnStats @goToPro="seeProAdvantages = true" />

      <div class="d-flex align-center">
        <h2>{{ $t('titles_JournalStats.byMarket') }}</h2>
        <v-chip class="ml-2" small>
          <p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p>
        </v-chip>
      </div>
      <ByMarketStats @goToPro="seeProAdvantages = true" />

      <!-- Overlay for educational video!-->
      <v-overlay :dark="false" v-model="overlayVideo">
        <EducationalVideo :title="title" :video-url="videoUrl" @closeWindow="overlayVideo = false" />
      </v-overlay>

      <!-- Overlay for Upgrade to Pro!-->
      <v-overlay :dark="false" v-model="seeProAdvantages">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="seeProAdvantages = false" />
      </v-overlay>

      <!-- Overlay for Loading Trades!-->
      <v-overlay :dark="false" v-model="$store.state.book.loadingTrades">
        <lottie :options="lottieOptions" :height="250" :width="250" />
      </v-overlay>
    </div>
    <div class="mobile">
      <h3 class="text-center my-16">
        <v-icon class="d-flex align-center justify-center mt-12 mb-5" x-large>fa-regular fa-grin-beam-sweat</v-icon>
        {{ $t('messageMobile') }}
      </h3>
    </div>
  </v-card>
</template>

<script>

    import * as animationData from '@/assets/animations/loading.json';
    import AssetStats from "../AssetStats";
    import PortfolioStats from "../PortfolioStats";
    import TimeStats from "../TimeStats";
    import StrategyStats from "../StrategyStats";
    import SideStats from "../SideStats";
    import MoodStats from "../MoodStats";
    import EducationalVideo from "../../../components/EducationalVideo";
    import SwisetRatioStats from "@/views/Journal/SwisetRatioStats";
    import RiskReturnStats from "@/views/Journal/RiskReturnStats";
    import UpgradeToPro from "@/components/UpgradeToPro";
    import ByMarketStats from "@/views/Journal/ByMarketStats";
    import OverallFilters from '../components/OverallFilters.vue';
    import {mapMutations} from 'vuex';
    export default {
        name: "BookStats",
        components: {
          ByMarketStats,
          UpgradeToPro, RiskReturnStats, SwisetRatioStats, EducationalVideo, MoodStats, SideStats, StrategyStats, TimeStats, PortfolioStats, AssetStats,OverallFilters
        },
        props: {
            externalUser: Boolean,
            externalUserId: Number,
        },
        inject:["isEmbedded"],
        mounted(){
        },
        data() {
            return {
                lottieOptions: { animationData: animationData.default, },
                seeProAdvantages: false,
                messageUpgradeToPro: 'You cannot see pro stats. With Pro you can get all the professional statistics and more.',

      // Educational Video
      overlayVideo: false,
      title: 'Profitability Stats',
      videoUrl: 'n0kW2kozmxw',
    };
  },
  methods: {
    ...mapMutations(['setTradesPageable']),
    backToTrades() {
      this.setTradesPageable({
        size: 15,
        page: 0,
        sort: 'openTime,desc',
      });
      this.$router.push((this.externalUser) ? '/book/shared' : '/book');
    },
    educationalVideo(stat) {
      switch (stat) {
        case 'Portfolio':
          this.title = this.$t('titles.portfolio');
          this.videoUrl = 'WFOaSVvkKe4';
          break;
        case 'Profitability':
          this.title = this.$t('titles.profitability');
          this.videoUrl = 'n0kW2kozmxw';
          break;
        case 'Asset':
          this.title = this.$t('titles.asset');
          this.videoUrl = 'COcgXbpa2gg';
          break;
        case 'Side':
          this.title = this.$t('titles.side');
          this.videoUrl = 'COPFcGvoQ84';
          break;
        case 'Time':
          this.title = this.$t('titles.time');
          this.videoUrl = 'bMzDWVvYfUE';
          break;
        case 'Mood':
          this.title = this.$t('titles.mood');
          this.videoUrl = 'Zl7rYLwYvaQ';
          break;
        case 'SwisetRatio':
          this.title = this.$t('titles.swisetRatio');
          this.videoUrl = 'JkzLCKGG_3g';
          break;
        default:
          this.title = this.$t('titles.strategy');
          this.videoUrl = '08H9np6sZvQ';
          break;
      }
      this.overlayVideo = true;
    },
    setChartsToDark() {
      
    }
  }
}
</script>



<style scoped>
.fixed-component {
  background-color: var(--v-light-base);
  position: relative;
  z-index: 1;
}

.old-filters {
  display: none;
}

@media (min-width: 600px) {
  .mobile {
    display: none;
  }
}

@media (max-width: 599px) {
  .desktop {
    display: none;
  }
}
</style>
